export function sanitizeDateFilterValue(
  filter: ((timezone: string) => string) | string,
  timezone: string
): string {
  return typeof filter === 'function' ? filter(timezone) : filter;
}
